<template lang="pug">
  .container
    .columns
      .column.is-full-mobile.is-three-quarters-tablet.is-three-quarters-desktop.is-three-quarters-widescreen.is-three-quarters-fullhd
        Grafica(:chart-data="dataGrafica" :options="options" :plugins="plugin" :width='width' :height='heigth')
        .columns
          .column.is-4
            label.label Fecha Inicio:
              .field
                .control
                  flat-pickr(
                    v-model="fechaGrafica_ini"
                    :config="configWithTime"
                    class="input"
                  )
          .column.is-4
            label.label Fecha Fin:
              .field
                .control
                  flat-pickr(
                    v-model="fechaGrafica_fin"
                    :config="configWithTime"
                    class="input"
                  )
          .column.is-4
            a.button.is-text.is-rounded.mt-30.is-top(@click="getDataGraficaValvulas")
              i.fas.fa-sync
              | &nbspGenerar Gŕafica
            | &nbsp
            a.button.is-text.is-rounded.mt-30.is-top(@click="descargarGrafica")
              i.fas.fa-file-download  
              | &nbspDescargar Gŕafica
            | &nbsp
      .column.is-full-mobile.is-one-quarter-tablet.is-one-quarter-desktop.is-one-quarter-widescreen.is-one-quarter-fullhd
        .card
          .card-content
            .columns
              .buttons.has-addons
                span.button.btn-tipoValvula(@click="selectValvula(0)") Bis
                span.button.btn-tipoValvula(@click="selectValvula(1)") Todas
                span.button.btn-tipoValvula(@click="selectValvula(2)") Secc.
            .columns
              .column.is-half-desktop.is-full-mobile
                div(v-for="v in valvulas")
                  p.has-text-grey-dark {{ v.alias }}: &nbsp
                    b.has-text-dark {{ v.valor }}

        .card(v-if="tipo== 0")
          .card-content 
            .columns
              .column.is-8
                label.label Fecha de reporte:
                  .field
                    .control
                      flat-pickr(
                        v-model='fechaReporteBis'
                        :config="config"
                        class="input"
                      )
              .column.is-2.button-bottom
                a.button.is-black.is-rounded.is-small.mt-30.is-top(@click="descargarReporteBis")
                    i.fas.fa-print
                | &nbsp

        .card(v-if="tipo== 2")
          .card-content 
            .columns
              .column.is-8
                label.label Fecha de reporte:
                  .field
                    .control
                      flat-pickr(
                        v-model='fechaReporte'
                        :config="config"
                        class="input"
                      )
              .column.is-2.button-bottom
                a.button.is-black.is-rounded.is-small.mt-30.is-top(@click="descargarReporte")
                    i.fas.fa-print 1
                | &nbsp
              .column.is-2.button-bottom
                a.button.is-black.is-rounded.is-small.mt-30.is-top(@click="descargarReporte2")
                    i.fas.fa-print 2
                | &nbsp
</template>

<script>
import ductosServices from '@/services/ducto'
import NotificacionConst from '@/components/shared/NotificacionConst.vue'
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet';
import { jsPDF } from 'jspdf'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from "flatpickr/dist/l10n/es.js"
import Grafica from './Grafica.vue'
import plugin from './plugin';

export default {
  name: 'Valvulas',
  components: { LMap, LTileLayer, LMarker, LTooltip, NotificacionConst, flatPickr, Grafica },
  props: {
    activo: {
      type: Boolean,
      default: 1
    },
  },
  data () {
    return {
      refresh: null,
      valvulas: {},
      zoom: 9,
      center: L.latLng(20.444726, -98.241468),
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(20.444726, -98.241468),
      tipo: 1,
      activarData: this.activo,
      fechaGrafica_ini: null,
      fechaGrafica_fin: null,
      fechaReporte: null,
      fechaReporteBis: null,
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: Spanish, // locale for this instance only          
      },
      configWithTime: {
        enableTime: true,
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'Y-m-d H:00',
        altInput: true,
        dateFormat: 'Y-m-d H:00',
        locale: Spanish, // locale for this instance only          
      },
      nombreGrafica: '',
      dataGrafica: {},
      width: 800,
      heigth: 400,
      options: {
        responsive: true,
        lineTension: 1,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Horas'
            }
          },
          y: {
            ticks: {
              beginAtZero: true,
              padding: 5
            },
            title: {
              display: true,
              text: 'Presión'
            }
          },
        },
        plugins: {
          title: {
            display: true,
            text: this.nombreGrafica,
          },
          customCanvasBackgroundColor: {
            color: '#ffffff',
          },
        }
      },
      plugin: [plugin]
    }
  },
  watch: {
    activo (active) {
      console.log(active)
      this.activarData = active 
      if (active) {
        this.iniciarComponente()
      } else {
        clearInterval(this.refresh)
      }
    },
  },
  methods: {
    descargarReporteBis() {
      const currentUrl = window.location.hostname
      let link = ''
      if (currentUrl === '10.122.40.189') {
        link = `http://${currentUrl}//servidores/reportes/monitoreo/valvulaSec1_13.php?fecha=${this.fechaReporteBis}`
      }
      else {
        link = `https://${currentUrl}//servidores/reportes/monitoreo/valvulasBis.php?fecha=${this.fechaReporteBis}`
      }
      open(link, '_blank')
    },
    descargarReporte(){
      const currentUrl = window.location.hostname
      let link = ''
      if (currentUrl === '10.122.40.189') {
        link = `http://${currentUrl}//servidores/reportes/monitoreo/valvulaSec1_13.php?fecha=${this.fechaReporte}`
      }
      else {
        link = `https://${currentUrl}//servidores/reportes/monitoreo/valvulaSec1_13.php?fecha=${this.fechaReporte}`
      }
      open(link, '_blank')
    },
    descargarReporte2(){
      const currentUrl = window.location.hostname
      let link2 = ''
      if (currentUrl === '10.122.40.189') {
        link2 = `http://${currentUrl}//servidores/reportes/monitoreo/valvulaSec14_26.php?fecha=${this.fechaReporte}`
      }
      else {
        link2 = `https://${currentUrl}//servidores/reportes/monitoreo/valvulaSec14_26.php?fecha=${this.fechaReporte}`
      }
      open(link2, '_blank')
    },
    openMultipleLinks(links) {
      for (var i = 0; i < links.length; i ++) {
        window.open(links[i]);
      } 
    },
    iniciarComponente () {
      this.refresh = setInterval(() => {
        if (this.activarData) {
          this.obtenerDatosValvulas()
        } else {
          console.log('No hacer nada')
          clearInterval(this.refresh)
        }
      }, 10000)
    },
    obtenerDatosValvulas () {
      ductosServices.getValvulas()
        .then(data => {
          switch (this.tipo) {
            case 0:
              this.valvulas = data.filter(val => val.tipo === 'b')
              this.nombreGrafica = 'Válvulas Bis'
              break;
            case 1:
              this.valvulas = data
              break;
            case 2:
              this.valvulas = data.filter(val => val.tipo === 's')
              this.nombreGrafica = 'Válvulas Seccionamiento'
              break;
            default:
              break;
          }
        })
    },
    latlng: function (lat, lng) {
      return L.latLng(lat, lng)
    },
    textValvula: function (id, valor) {
      return `${id}: ${valor}`
    },
    selectValvula (vSel) {
      this.tipo = vSel
      let buttonsValv = document.querySelectorAll('.btn-tipoValvula')
      let botones = Array.from(buttonsValv)
      let ind = parseInt(this.tipo)
      botones[0].classList.remove('is-dark')
      botones[1].classList.remove('is-dark')
      botones[2].classList.remove('is-dark')
      botones[ind].classList.add('is-dark')
      this.obtenerDatosValvulas()
    },

    getDataGraficaValvulas(){
      console.log(this.fechaGrafica_ini)
      console.log(this.fechaGrafica_fin)
      console.log(this.tipo)

      if (this.tipo == 2 ) {
        ductosServices.getValvulas_fecha(this.fechaGrafica_ini, this.fechaGrafica_fin)
          .then(data => {
            this.arreglarDataGrafica(data)
          })
      } else {
        ductosServices.getValvulas_fecha_bis(this.fechaGrafica_ini, this.fechaGrafica_fin)
          .then(data => {
            this.arreglarDataGrafica(data)
          })
      }
    },

    arreglarDataGrafica(data) {
      const { horas, valvulas, valores } = data

      
      
      const colores = [
        {"background": "#7a8eff", "borderColor": "#4fc3f7"},
        {"background": "#ff8a65", "borderColor": "#81c784"},
        {"background": "#ffd54f", "borderColor": "#e57373"},
        {"background": "#81c784", "borderColor": "#f06292"},
        {"background": "#4db6ac", "borderColor": "#ffb74d"},
        {"background": "#ba68c8", "borderColor": "#4dd0e1"},
        {"background": "#e57373", "borderColor": "#64b5f6"},
        {"background": "#f06292", "borderColor": "#ba68c8"},
        {"background": "#64b5f6", "borderColor": "#81c784"},
        {"background": "#4dd0e1", "borderColor": "#ffd54f"},
        {"background": "#ffb74d", "borderColor": "#f06292"},
        {"background": "#4fc3f7", "borderColor": "#ba68c8"},
        {"background": "#ba68c8", "borderColor": "#64b5f6"},
        {"background": "#4fc3f7", "borderColor": "#ffd54f"},
        {"background": "#81c784", "borderColor": "#4db6ac"},
        {"background": "#ffd54f", "borderColor": "#e57373"},
        {"background": "#f06292", "borderColor": "#ba68c8"},
        {"background": "#64b5f6", "borderColor": "#4dd0e1"},
        {"background": "#ba68c8", "borderColor": "#ff8a65"},
        {"background": "#81c784", "borderColor": "#4fc3f7"},
        {"background": "#4db6ac", "borderColor": "#ffb74d"},
        {"background": "#e57373", "borderColor": "#64b5f6"},
        {"background": "#ff8a65", "borderColor": "#81c784"},
        {"background": "#4fc3f7", "borderColor": "#f06292"},
        {"background": '#ff4d4d', "borderColor": '#b83844' },
        {"background": '#057d8d', "borderColor": '#057d8d' },
      ]
      
      const datasetsGrafica = []

      for (let index = 0; index < valores.length; index++) {
        const myObj = {
          label: valvulas[index],
          data: valores[index],
          backgroundColor: colores[index].background,
          borderColor: colores[index].borderColor,
          borderWidth: 2,
        }
        datasetsGrafica.push(myObj)
      }

      this.dataGrafica = {
        labels: horas,
        datasets: datasetsGrafica,
      }
    },
    
    descargarGrafica() {
      const doc = new jsPDF({
        orientation: 'landscape'
      })
      var canvas = document.getElementById("line-chart");
      var data_url = canvas.toDataURL("image/png")

      const tipo = this.tipo === 0 ? 'Válvulas Bis' : 'Válvulas de Seccionamiento'
      const name = this.tipo === 0 ? 'valvulas_bis' : 'valvulas_seccionamiento'
      const title = `Gráfica de ${tipo}`
      const text_fecha = `Consulta: ${this.fechaGrafica_ini} al ${this.fechaGrafica_fin}`

      doc.setFontSize(12)
      doc.text(title, 20,15)
      doc.text(text_fecha, 180, 15)
      doc.addImage(data_url, 'PNG',30,20,250,150)
      doc.save(`grafica_${name}_${this.fechaGrafica_ini}_${this.fechaGrafica_fin}.pdf`)

    }
  },
  beforeDestroy() {
    clearInterval(this.refresh)
    console.log(this.refresh)
  },
  created () {
    this.iniciarComponente()
    this.nombreGrafica = 'Válvulas Seccionamiento'
    this.fechaReporte = moment().format('YYYY-MM-DD')
    this.fechaGrafica_ini = moment().format('YYYY-MM-DD 05:00')
    this.fechaGrafica_fin = moment().add(1, 'day').format('YYYY-MM-DD 05:00')
    this.fechaReporteBis = moment().format('YYYY-MM-DD')
  },
  mounted () {
    this.selectValvula(1)
    setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250)
  },
}
</script>

<style lang="css" scoped>

.mt-30{
    margin-top: 30px !important;
  }

  #mapa {
    height: 700px;
    width: 100%;
    margin: 0;
  }

  .vue2leaflet-map.leaflet-container.leaflet-touch.leaflet-fade-anim.leaflet-grab.leaflet-touch-drag.leaflet-touch-zoom {
    border: 2px solid #203a69;
    border-radius: 10px;
  }

  @media (min-width:320px) {
    #mapa {
    height: 300px;
    width: 95%;
    margin: 0;
    }
  }

  @media (min-width:320px) and (orientation: landscape) {
  /* smartphones, iPhone, portrait 480x320 phones */ 
    #mapa {
      height: 300px;
      margin: 0;
    }
  }

  @media screen and (max-width: 600px) {
    #mapa {
      height: 300px;
      margin: 0;
    }
  }

  @media (min-width:481px) {
    /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
    #mapa {
      height: 300px;
      margin: 0;
    }
  }

  @media (min-width:641px) {
    /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */ 
    #mapa {
      height: 500px;
      margin: 0;
    }
  }
  @media (min-width:961px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */ 
    #mapa {
      height: 500px;
      margin: 0;
    }
  }

  @media (min-width:1025px) { 
    /* big landscape tablets, laptops, and desktops */ 
    #mapa {
      height: 650px;
      margin: 0;
    }
  }
  @media (min-width:1281px) { 
    /* hi-res laptops and desktops */ 
    #mapa {
      height: 650px;
      margin: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/Valvulas.vue